import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next'
import { AccountPickerUserInfoProps } from './account-picker';
import "./account-picker.css"


export function AccountPickerUserInfo(props: AccountPickerUserInfoProps) {

    const { guid, playerId, displayName, isButton, isCurrent, buttonClick, ...htmlProps } = props
    const { t } = useTranslation()

    const handleClick = () => {
        if (buttonClick) {
            buttonClick(guid)
        }
    }

    useEffect(() => {
        if (guid && isCurrent) {
            const element = document.getElementById(guid + '-user-info-button')
            if (element) {
                element.focus()
            }
        }
    }, [isCurrent])



    let ariaSelectedAccountName = t('selected_account_name', `${displayName}. This is the selected account.`)

    if (isButton) {
        return (
            <button className='acc-picker-user-info-main' onClick={handleClick} id={`${guid}-user-info-button`} data-testid={`${guid}-user-info-button`} aria-label={isCurrent ? ariaSelectedAccountName : displayName}>
                <div className='acc-picker-user-info-container'>
                    <img className='acc-picker-user-info-icon' src='https://static.pokemon.com/images/user_circle.svg' alt='' />
                    <div className='acc-picker-user-info-data'>
                        <span className='acc-picker-user-info-screen-name' >{displayName}</span>
                        {playerId ? <span className='acc-picker-user-info-id' >{t('player_id', 'Player ID')}: {playerId}</span> : undefined}
                    </div>
                </div>
                {isCurrent && <img className='acc-picker-user-info-check' src='https://static.pokemon.com/images/blue_circle_check.svg' alt='' />}
            </button>
        );
    } else {
        return (
            <div className='acc-picker-user-info-main' data-testid={`${guid}-user-info-div`}>
                <img className='acc-picker-user-info-icon' src='https://static.pokemon.com/images/user_circle.svg' alt='' />
                <div className='acc-picker-user-info-data'>
                    <span className='acc-picker-user-info-screen-name' >{displayName}</span>
                    {playerId ? <span className='acc-picker-user-info-id' >{t('player_id', 'Player ID')}: {playerId}</span> : undefined}
                </div>
            </div>
        );
    }
}
